export const gqlVar = <T = unknown>(variables: T) => ({ variables });
